export default __webpack_public_path__ + "static/avatar-kayi-special-0-f0ab734b6adc7c20a9e9a0885b0caa0b.png";